import { Flyout } from "components/Flyout/Flyout";
import { FileBrowserGdt } from "components/FlyoutFiles/FlyoutFilesGDT";
import { useDataTableContext } from "../store/DataTableProvider";

interface DataTableFlyoutBottomProps {
  content: "fileBrowser" | undefined;
  onClose: () => void;
}

/** Component that renders a bottom flyout for a data table */
export const DataTableFlyoutBottom = ({
  content,
  onClose,
}: DataTableFlyoutBottomProps) => {
  const projectKey = useDataTableContext((s) => s.project.key);

  if (content === undefined) {
    return null;
  }

  return (
    <Flyout
      title="File Browser"
      titleSpacerSize="xs"
      onClose={onClose}
      css={{
        display: "flex",
        flex: 1,
        height: "100%",
      }}
    >
      <div style={{ display: "flex", minHeight: 200, height: "100%" }}>
        <FileBrowserGdt projectKey={projectKey} />
      </div>
    </Flyout>
  );
};
